import { useEffect } from 'react'

export const useMetaPixel = (pixelId: string) => {
  useEffect(() => {
    // Initialize Facebook Pixel with safer script injection
    const initPixel = () => {
      if (typeof window === 'undefined') return

      // Skip if already initialized
      if ((window as any).fbq) return

      // Create fbq function
      const fbq = function (...args: any[]) {
        if ((fbq as any).callMethod) {
          ;(fbq as any).callMethod.apply(fbq, args)
        } else {
          ;(fbq as any).queue.push(args)
        }
      } as any

      fbq.push = fbq
      fbq.loaded = true
      fbq.version = '2.0'
      fbq.queue = []
      ;(window as any).fbq = fbq
      ;(window as any)._fbq = fbq

      // Safely inject the script
      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'

      // Use head or body, whichever is available
      const target = document.head || document.body || document.documentElement
      if (target) {
        target.appendChild(script)
      }

      // Initialize pixel after setup
      ;(window as any).fbq('init', pixelId)
      ;(window as any).fbq('track', 'PageView')
    }

    initPixel()
  }, [pixelId])

  const trackEvent = (event: string, data?: any) => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;(window as any).fbq('track', event, data)
    }
  }

  return { trackEvent }
}
